import { cva } from 'class-variance-authority';

export const labelClasses = cva('flex cursor-pointer items-center gap-4', {
  variants: {
    disabled: {
      true: 'cursor-not-allowed opacity-50'
    }
  }
});

export const hiddenInputClasses = cva('absolute h-0 w-0 opacity-0');

export const customCheckboxClasses = cva(
  'p-0-5 flex min-h-[18px] min-w-[18px] items-center justify-center rounded-xs border-1 border-solid transition-all duration-200',
  {
    variants: {
      checked: {
        true: 'border-charcoal-500 bg-white-50',
        false: 'border-pebble-500 bg-white-50'
      }
    }
  }
);

export const checkboxIconClasses = cva('fill-white-500', {
  variants: {
    checked: {
      true: 'opacity-100',
      false: 'opacity-0'
    }
  }
});
